"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _components = require("@engaging-tech/components");

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _useNavContext2 = _interopRequireDefault(require("../../hooks/useNavContext"));

var _ExpandableNavItem = _interopRequireDefault(require("./ExpandableNavItem"));

var _SingleNavItem = _interopRequireDefault(require("./SingleNavItem"));

var NavWrapper = (0, _styledComponents["default"])(_components.Box).withConfig({
  displayName: "NavItems__NavWrapper",
  componentId: "sc-12neswn-0"
})(["border-bottom:1px solid ", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.primary[1];
});
/**
 * Renders the main navigation routes. This component
 * is **mobile-only**.
 * @package
 */

var NavItems = function NavItems() {
  var _useNavContext = (0, _useNavContext2["default"])(),
      toggleDrawer = _useNavContext.toggleDrawer,
      routes = _useNavContext.routes;

  if (routes.length === 0) {
    return null;
  }

  return /*#__PURE__*/_react["default"].createElement(NavWrapper, {
    width: "auto",
    pt: 2,
    pb: 2
  }, routes.map(function (route) {
    var nonPrivateChildren = route.children ? route.children.filter(function (child) {
      return !child["private"];
    }) : [];
    return !nonPrivateChildren.length ? /*#__PURE__*/_react["default"].createElement(_SingleNavItem["default"], {
      key: route.description,
      route: route,
      rootItem: true,
      onNavigate: toggleDrawer // @ts-ignore
      ,
      fontSize: 18,
      mb: 3,
      mt: 3
    }) : /*#__PURE__*/_react["default"].createElement(_ExpandableNavItem["default"], {
      key: route.description,
      route: route,
      childRoutes: nonPrivateChildren,
      onNavigate: toggleDrawer
    });
  }));
};

var _default = NavItems;
exports["default"] = _default;